<template>
    <div class="sustainable-component common-mce-editor" :data-testid="testIdBase ? `${testIdBase}-container` : null">
        <div class="container-fluid p-2 border border-dark rounded" style="border-color:black;background-color:white;">
            <div class="row" style="position:relative">
                <span class="title px-1">
                    {{title}}
                </span>
            </div>
            <div class="row">
                <div class="col">
                    <editor api-key="ean2nl7prjqb1unjkg6kltidatbm2xw31kalfemhvh3vw07n"
                            :plugins="plugins"
                            :toolbar="toolbar"
                            v-model="editorcontent"
                            :init="{ ...initSettings, body_class: testIdBase ? `${testIdBase}-body` : '' }"
                            :readonly="disabled"
                            :disabled="disabled"
                            />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

    // eslint-disable-next-line
    const editorcontent = defineModel('editorcontent', {
        type: String,
        default: ""
    });

    // eslint-disable-next-line
    const props = defineProps({
        title: String,
        testIdBase: {
            type: String,
            default: ""
        },
        disabled: {
            type: Boolean,
            default: false
        },
    })
    
</script>

<script>

    import Editor from '@tinymce/tinymce-vue'

    export default {

        name: 'common-mce-editor',
        components: {
            'editor': Editor
        },
        methods: {
        },
        data() {
            return {
                toolbar: "bold italic underline link image media code | bullist numlist fullscreen",
                plugins: "link lists fullscreen",
                initSettings: {
                    forced_root_block: false,
                    menubar: false,
                    extended_valid_elements: 'i[class],em[class]',
                    keep_styles: false,
                    convert_urls: false,
                    relative_urls: false,
                    content_style: ".mce-content-body {padding-left: 5px; padding-right: 5px }",
                    browser_spellcheck: true,
                    contextmenu: false,
  
                }
            };
        },
        watch: {

        },
        mounted() {
            //alert("disabled:" + this.disabled)
        },
    }
</script>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .sustainable-component .title {
        color: black;
        background-color: white;
        position: absolute;
        top: -18px;
        left: 14px;
        width: fit-content;
        font-size: 12px;
        font-weight: 400
    }

    
</style>

<style>

    .tox-tinymce {
        border: 1px solid white !important;
    }

    .tox-statusbar {
        border-top: 1px solid white !important;
    }
</style>
